import { createFileRoute } from "@tanstack/react-router";
import { WandSparklesIcon } from "lucide-react";
import { PublicSign } from "@/ui/components/ai-documents/public-sign";

/**
 * Public, account-less signing page. Deliberately outside every auth gate so an
 * external signer can open their link and sign without logging in.
 */
export const Route = createFileRoute("/sign/$token")({
  component: SignPage,
});

function SignPage() {
  const { token } = Route.useParams();
  return (
    <main className="min-h-svh bg-muted/30 px-4 py-10">
      <div className="mx-auto w-full max-w-2xl space-y-6">
        <div className="flex items-center gap-2">
          <span className="flex size-8 items-center justify-center rounded-lg bg-primary/10">
            <WandSparklesIcon className="size-4 text-primary" />
          </span>
          <div>
            <p className="font-semibold text-sm tracking-tight">HR Docket</p>
            <p className="text-muted-foreground text-xs">
              Review the document and add your signature.
            </p>
          </div>
        </div>
        <PublicSign token={token} />
      </div>
    </main>
  );
}
